/*
  Voraussichtliches Lieferdatum aus Werktagen.

  Warum im Browser und nicht in Liquid: Shopify legt fertige Seiten
  zwischen. Ein in Liquid gerechnetes Datum waere dann irgendwann von
  gestern. Im Browser stimmt es immer.

  Rechenweg: vom heutigen Tag so viele Tage weiterzaehlen, bis die
  eingestellte Zahl an WERKTAGEN erreicht ist. Samstag und Sonntag
  zaehlen nicht mit. Feiertage kennt die Rechnung nicht - dafuer
  braeuchte es eine gepflegte Liste.
*/
(function () {
  var TAGE = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  var TAGE_KURZ = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  var MONATE = [
    'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
    'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember',
  ];

  function werktageAddieren(start, anzahl) {
    var d = new Date(start.getTime());
    var offen = anzahl;
    // Ist der Startzeitpunkt selbst ein Wochenende, beginnt die Zaehlung
    // erst am naechsten Werktag.
    while (d.getDay() === 0 || d.getDay() === 6) {
      d.setDate(d.getDate() + 1);
    }
    while (offen > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) offen--;
    }
    return d;
  }

  function formatieren(d, muster) {
    return muster
      .replace('{wochentag}', TAGE[d.getDay()])
      .replace('{wt}', TAGE_KURZ[d.getDay()])
      .replace('{tag}', d.getDate())
      .replace('{monat}', MONATE[d.getMonth()])
      .replace('{jahr}', d.getFullYear());
  }

  function start() {
    document.querySelectorAll('[data-hss-delivery]').forEach(function (el) {
      var ziel = el.querySelector('[data-hss-delivery-text]');
      if (!ziel) return;
      var tage = parseInt(el.dataset.werktage, 10);
      if (isNaN(tage) || tage < 0) return;
      var muster = el.dataset.muster || '';
      if (!muster) return;
      var datum = werktageAddieren(new Date(), tage);
      ziel.textContent = formatieren(datum, muster);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();
